import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
const TogelGameBlock = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('attention')} !</h4>
            <p> {props.t('togel_game_block')}.</p>
            <p> {props.t('thank_you')}.</p>
        </div>
    )
}

TogelGameBlock.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(TogelGameBlock);